import React from 'react'
import ItemImage from '../ItemImage';
import Modal from '../modal'
import Thumbs from './Thumbs'
import styled from 'styled-components'

const Disclaimer = styled.div`
    font-size: 16px;
    color: grey;
`

const ImgContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 500px;
    max-width: 100%;
`

const ThumbsContainer = styled.div`
    display: flex;
    justify-content: center;
    margin-top: 20px;
`

export default function ImageModal(props) {
    const { open, onClose, grouped, groupedKey, setGroupedKey } = props

    const disclaimer = 'Images are representative only.'
    const groupedLength = Object.keys(grouped)?.length

    return (
        <Modal {...{
            open,
            onClose,
            contentStyle: { width: window.innerWidth < 700 ? '100%' : null, overflow: 'scroll', maxHeight: '100%' }
        }}>
            <ImgContainer>
                <ItemImage {...{
                    details: { itemMedia: grouped[groupedKey] },
                    size: 'original',
                    link: 'self'
                }} />
            </ImgContainer>
            {groupedLength > 1 && (
                <ThumbsContainer>
                    <Thumbs {...{ grouped, groupedKey, setGroupedKey }} />
                </ThumbsContainer>
            )}
            <Disclaimer>{disclaimer}</Disclaimer>
        </Modal>
    )
}